module["exports"] = ["United States", "United States of America", "USA"];